import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledSpan = styled(Typography)(({ theme }) => ({
  strong: {
    color: theme.palette.hubColors.mainFocus,
    textWrap: "nowrap",
  },
}));
